// removed by extract-text-webpack-plugin
module.exports = {"icon-palette":"icon-palette","palette-page-control":"palette-page-control","disabled":"disabled","palette-page-control-up":"palette-page-control-up","palette-page-control-down":"palette-page-control-down","palette-grid":"palette-grid","grid-item-container":"grid-item-container","grid-item":"grid-item","palette-item":"palette-item","selected":"selected","palette-item-icon":"palette-item-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category-edit-modal/component/icon-palette/icon-palette.style.sass
// module id = MHsw
// module chunks = 0